import Router from './Router';
import PrimaryNav from './components/navigation/PrimaryNav';
import './assets/scss/app.scss';

import AuthState from './context/auth/auth-state';

const App = () => {
  return (
      <div className="fiterr-app-container">
        <AuthState>
          <PrimaryNav/>
          <Router />
        </AuthState>
      </div>
  );
}

export default App;